import React, { useEffect, useState } from "react";
import Header from "../common/Header";
import $ from "jquery";
import { Link } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { monthNames } from "../helpers/date";
import { getInvoicePreview } from "../helpers/processprintdata";
import ConfirmModal from "../../modal/ConfirmModal";
import DateRangePicker from "../common/DateRangePicker";
import { GETREQUEST, PATCHREQUEST } from "../helpers/ServiceRequest";
import { formatInvoiceNo } from "../helpers/common";

const AllInvoices = () => {
    let currentDate = new Date();
    var currentMonth = currentDate.getMonth() + 1;
    let currentDay = currentDate.getDate();
    if (currentDay < 10) currentDay = "0" + currentDay;
    if (currentMonth < 10) {
        currentMonth = "0" + currentMonth;
    }
    let date = currentDate.getFullYear() + "-" + currentMonth + "-" + currentDay;
    const [SearchInvoiceNo, setSearchInvoiceNo] = useState("");
    const [SearchCustomerCode, setSearchCustomerCode] = useState("");
    const [SearchCustomerName, setSearchCustomerName] = useState("");
    const [SearchPONumber, setSearchPONumber] = useState("");
    const [sortColumn, setSortColumn] = useState("InvoiceNo");
    const [sortBy, setSortBy] = useState("ASC");

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [invoices, setInvoices] = useState([]);
    const [showInvoices, setShowInvoices] = useState([]);
    const [totalPages, setTotalPages] = useState();
    const [totalItems, setTotalItems] = useState();
    const [page, setPage] = useState(0);
    const [size, setSize] = useState(25);
    const [currentPage, setCurrentPage] = useState();
    const [loading, setLoading] = useState(true);
    const [showDateRange, setShowDateRange] = useState(false);
    const [previewConfirmModal, setPreviewConfirmModal] = useState(false);
    const [toggleArchivedInvoice, settoggleArchivedInvoice] = useState(false);
    const [id, setId] = useState(null);
    const { user } = useAuth();

    useEffect(() => {
        var headerHeight = $("header").outerHeight();
        var mainHeight = $(window).height() - headerHeight;
        $("main").height(mainHeight);
        $("main").css("margin-top", headerHeight - 20 + "px");
    });

    useEffect(() => {
        getAllInvoices()
    }, [page, size, sortColumn, sortBy, SearchInvoiceNo, SearchCustomerCode, SearchCustomerName, SearchPONumber, startDate, endDate]);

    const handleSort = (sortName) => {
        setSortColumn(sortName);
        if (sortBy == "")
            setSortBy("ASC")
        else if (sortBy == "ASC")
            setSortBy("DESC")
        else
            setSortBy("ASC")
    }

    const getAllInvoices = async () => {
        setLoading(true);
        let PCURL =
            process.env.REACT_APP_API_URL + `/get-invoices?page=${page}&size=${size}`;
        let queryParams = [];

        if (SearchInvoiceNo) queryParams.push(`SearchInvoiceNo=${SearchInvoiceNo}`);
        if (SearchCustomerCode) queryParams.push(`SearchCustomerCode=${SearchCustomerCode}`);
        if (SearchCustomerName) queryParams.push(`SearchCustomerName=${SearchCustomerName}`);
        if (SearchPONumber) queryParams.push(`SearchPONumber=${SearchPONumber}`);
        if (startDate && endDate) queryParams.push(`startDate=${startDate}&endDate=${endDate}`);
        if (sortColumn && sortBy) queryParams.push(`sortColumn=${sortColumn}&sortBy=${sortBy}`);

        if (queryParams.length > 0) PCURL += `&${queryParams.join('&')}`;
        let response = await GETREQUEST(PCURL, user.jwtToken);
        if (response?.data) {
            const invoices = response.data.data.filter((invoice) => invoice.OrderStatus == 'I');
            setLoading(false);
            setInvoices(response.data.data);
            setShowInvoices(invoices)
            setTotalPages(response.data.totalPages);
            setTotalItems(response.data.totalItems);
            setCurrentPage(response.data.currentPage);
        }
    }
    const ArchivedInvoice = async() => {
        let ARURL = process.env.REACT_APP_API_URL + `/archived-invoice`;
        let payload = { InvoiceNo: id }
        let response = await PATCHREQUEST(ARURL, payload, user.jwtToken);
        if (response?.data) {
            setId(null);
            getAllInvoices();
        }
    }

    const handleDateRange = (startDate, endDate) => {
        setStartDate(startDate ? startDate.format('YYYY/MM/DD') : null);
        setEndDate(endDate ? endDate.format('YYYY/MM/DD') : null);
    }

    const getStartPageIndex = () => {
        return page === 0 ? 1 : page * size + 1;
    };

    const getEndPageIndex = () => {
        if (page === 0) {
            return showInvoices.length;
        }
        const endIndex = (page + 1) * size;
        return endIndex > totalItems ? totalItems : endIndex;
    };

    return (
        <React.Fragment>
            <Header />
            {previewConfirmModal && (
                <ConfirmModal modal={previewConfirmModal} modalHeader="Archived Invoice ?" modalBody="You are about to archived Invoice. Are you sure ?" setModal={setPreviewConfirmModal} onConfirm={ArchivedInvoice} />
            )}

            <main className="overflow-auto">
                <section className="p-4 table-listing">
                    <div className="table-elements">
                        <div className="paginations d-flex align-items-center p-2">
                            <p className="fs-14 text-lite mb-1 me-2">
                                Showing Results{" "}
                                <span className="text-dark">{totalItems == 0 ? 0 : getStartPageIndex()}</span> -{" "}
                                <span className="text-dark">{getEndPageIndex()}</span> of{" "}
                                <span className="text-dark">{totalItems}</span>
                            </p>
                            <ul className="list-inline mb-1">
                                {currentPage > 0 && (
                                    <li className="list-inline-item">
                                        <a style={{ cursor: "pointer" }} onClick={() => setPage(page - 1)}>
                                            {" "}
                                            <i className={`bi bi-chevron-left text-light`}></i>{" "}
                                        </a>
                                    </li>
                                )}
                                {totalPages > currentPage + 1 && (
                                    <li className="list-inline-item">
                                        <a style={{ cursor: "pointer" }} onClick={() => setPage(page + 1)}>
                                            {" "}
                                            <i className={`bi bi-chevron-right text-dark`}></i>{" "}
                                        </a>
                                    </li>
                                )}
                            </ul>
                            <div style={{ marginLeft: "10px" }}>
                                <select
                                    className="form-select input-sm cme-10"
                                    aria-label="Page size select example"
                                    style={{ width: "100px" }}
                                    value={size}
                                    onChange={(e) => { setSize(e.target.value); setPage(0) }}
                                >
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="card border-bottom-0 w-100">
                        <div className="card-header bg-white d-flex align-items-lg-center justify-content-between cpx-20 cpy-14 sticky-top flex-nowrap">
                            <h1 className="title-semibold fs-24 mb-xl-0 mb-0 d-flex align-items-center text-nowrap me-5 me-xl-0">
                                All Invoices
                            </h1>
                            <div className="filter-elements d-flex align-items-center">
                                <div className="custom-group flex-nowrap align-items-center">
                                    <label
                                        htmlFor=""
                                        className="pe-2 d-flex align-items-center fs-14 text-lite"
                                    >
                                        Filter by:
                                    </label>
                                    <DateRangePicker onSelected={handleDateRange} />
                                </div>
                                <button
                                    type="button"
                                    onClick={() => {
                                        let toggle = !toggleArchivedInvoice
                                        settoggleArchivedInvoice(toggle);
                                        if (toggle) {
                                            setShowInvoices([]);
                                            const archivedInvoices = invoices.filter((invoice) => invoice.OrderStatus == 'A');
                                            setShowInvoices(archivedInvoices)
                                        } else {
                                            const archivedInvoices = invoices.filter((invoice) => invoice.OrderStatus == 'I');
                                            setShowInvoices(archivedInvoices)
                                        }
                                    }}
                                    className={`btn btn-sm btn-outline-primary d-flex align-items-center px-4 fw-medium rounded-3 ms-3 text-nowrap ${toggleArchivedInvoice ? 'active text-white' : ''}`}

                                >
                                    Archived Invoices
                                </button>
                            </div>
                        </div>
                        <div className="card-body p-0 border-bottom">
                            <div className="table-responsive">
                                <table className="table table-hover mb-0">
                                    <thead>
                                        <tr>
                                            <th
                                                scope="col"
                                                className="width-lg-13 width-sm-auto  text-start "
                                            >
                                                <div>
                                                    <span style={{ cursor: "pointer" }} onClick={() => handleSort('InvoiceNo')}>Invoice No.</span>
                                                    {sortColumn == "InvoiceNo" &&
                                                        <span> <i className={`bi ${sortBy == "ASC" ? "bi-arrow-down-short" : "bi-arrow-up-short"}`}></i></span>
                                                    }
                                                </div>
                                                <div className="w-35 p-1">
                                                    <input
                                                        type="text"
                                                        className="form-control input-sm search"
                                                        placeholder="Search by Invoice No"
                                                        onChange={(e) => setSearchInvoiceNo(e.target.value)}
                                                    />
                                                </div>
                                            </th>
                                            <th scope="col" className="width-lg-8 width-sm-auto ps-3">

                                                <div>
                                                    <span style={{ cursor: "pointer" }} onClick={() => handleSort('OrderDate')}> Invoice Date</span>
                                                    {sortColumn == "OrderDate" &&
                                                        <span> <i className={`bi ${sortBy == "ASC" ? "bi-arrow-down-short" : "bi-arrow-up-short"}`}></i></span>
                                                    }
                                                </div>
                                                <div className="w-35 p-1">
                                                    <input
                                                        type="text"
                                                        className="form-control input-sm search"
                                                        style={{ visibility: "hidden" }}
                                                    />
                                                </div>
                                            </th>
                                            <th
                                                scope="col"
                                                className="width-lg-14 width-sm-auto"
                                            >
                                                <div>
                                                    <span style={{ cursor: "pointer" }} onClick={() => handleSort('CustomerCode')}>Customer Code</span>
                                                    {sortColumn == "CustomerCode" &&
                                                        <span> <i className={`bi ${sortBy == "ASC" ? "bi-arrow-down-short" : "bi-arrow-up-short"}`}></i></span>
                                                    }
                                                </div>
                                                <div className="w-35 p-1">
                                                    <input
                                                        type="text"
                                                        className="form-control input-sm search"
                                                        placeholder="Search by Cust. Code"
                                                        onChange={(e) => setSearchCustomerCode(e.target.value)}
                                                    />
                                                </div>
                                            </th>
                                            <th scope="col">
                                                <div>
                                                    <span style={{ cursor: "pointer" }} onClick={() => handleSort('CustomerName')}>Customer Name</span>
                                                    {sortColumn == "CustomerName" &&
                                                        <span> <i className={`bi ${sortBy == "ASC" ? "bi-arrow-down-short" : "bi-arrow-up-short"}`}></i></span>
                                                    }
                                                </div>
                                                <div className="w-35 p-1">
                                                    <input
                                                        type="text"
                                                        className="form-control input-sm search"
                                                        placeholder="Search by Customer Name"
                                                        onChange={(e) => setSearchCustomerName(e.target.value)}
                                                    />
                                                </div>
                                            </th>
                                            <th scope="col" className="width-lg-12 width-sm-auto">

                                                <div>
                                                    <span style={{ cursor: "pointer" }} onClick={() => handleSort('PONumber')}>P.O Number</span>
                                                    {sortColumn == "PONumber" &&
                                                        <span> <i className={`bi ${sortBy == "ASC" ? "bi-arrow-down-short" : "bi-arrow-up-short"}`}></i></span>
                                                    }
                                                </div>
                                                <div className="w-35 p-1">
                                                    <input
                                                        type="text"
                                                        className="form-control input-sm search"
                                                        placeholder="Search by PO NO."
                                                        onChange={(e) => setSearchPONumber(e.target.value)}
                                                    />
                                                </div>
                                            </th>
                                            <th scope="col" className="width-lg-5 width-sm-auto">
                                                Action
                                                <div className="w-35 p-1">
                                                    <input
                                                        type="text"
                                                        className="form-control input-sm search"
                                                        style={{ visibility: "hidden" }}
                                                    />
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody className="position-relative">
                                        {loading && (
                                            <tr className="position-absolute w-100 ">
                                                <td className="bg-white w-100 d-flex justify-content-center align-items-center p-1 border-0">
                                                    <div className="overlay">
                                                        <div
                                                            className="spinner-border text-primary"
                                                            role="status"
                                                        >
                                                            <span className="visually-hidden">
                                                                Loading...
                                                            </span>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                        {showInvoices.length == 0 && (
                                            <tr>
                                                <td colSpan={6} className="text-center">
                                                    No Record Found
                                                </td>
                                            </tr>
                                        )}
                                        {showInvoices.map((invoice, index) => {
                                            let date = new Date(invoice.InvoiceDate);
                                            return (
                                                <tr key={index}>
                                                    <td>{invoice.DisplayInvoiceNo}</td>
                                                    <td className="ps-3">{date.getDate()} {monthNames[date.getMonth()]} {date.getFullYear()}</td>
                                                    <td>{invoice.tblCustomer.CustomerCode}</td>
                                                    <td>{invoice.tblCustomer.CustomerName}</td>
                                                    <td>{invoice.PurchaseOrder}</td>
                                                    <td className="d-flex gap-2">
                                                        <button
                                                            onClick={() => getInvoicePreview(user, invoice.InvoiceNo)}
                                                            type="button"
                                                            className="btn btn-primary btn-xs d-inline-flex align-items-center text-white"
                                                        >
                                                            Preview
                                                        </button>
                                                        {invoice.OrderStatus == 'I' &&
                                                            <Link
                                                                to={`/amend-invoice/${invoice.InvoiceNo}`}
                                                                className="btn btn-outline-lite btn-xs d-inline-flex align-items-center text-dark"
                                                            >
                                                                Amend
                                                            </Link>
                                                        }

                                                        {invoice.OrderStatus == 'I' &&
                                                            <button
                                                                onClick={() => { setPreviewConfirmModal(true); setId(invoice.InvoiceNo) }}
                                                                type="button"
                                                                className="btn btn-outline-danger btn-xs d-inline-flex align-items-center"
                                                            >
                                                                Archived
                                                            </button>
                                                        }
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                        <tr></tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </React.Fragment>
    );
}

export default AllInvoices
